<template>
  <div>
  <el-dialog
    :close-on-click-modal="false"
    :visible.sync="visible"
    :title="rowInfo.id===''?'添加':'编辑'"
    width="60%">
    <span class="formContent">
      <el-form ref="rowInfo" :model="rowInfo" :rules="rules" label-width="100px">
        <el-row>
           <el-col :span="12" v-if="rowInfo.id==''">
             <el-form-item label="所属企业" prop="personNumber">
                <el-select
                  :disabled="rowInfo.id==''?false:true"
                  v-model="rowInfo.cusId"
                  placeholder="请选择所属企业"
                  style="width: 220px"
                  filterable
                  clearable>
                  <el-option v-for="item in cusList" :key="item.id" :label="item.cusName" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
           <el-col :span="12" v-if="rowInfo.id==''">
             <el-form-item label="下单人" prop="personNumber">
               <el-select
                 :disabled="rowInfo.id==''?false:true"
                 v-model="rowInfo.userId"
                 placeholder="请选择下单人"
                 style="width: 220px"
                 filterable
                 clearable>
                  <el-option v-for="item in cusEmpList" :key="item.userId" :label="item.empName" :value="item.userId"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="租车类型" prop="orderType">
               <select-text :disabled="rowInfo.id==''?false:true" v-model="rowInfo.orderType" code-set-id="1003" placeholder="租车类型" style="width: 220px"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
              <el-form-item label="用车类型" prop="carRentalLong">
              <el-select
                v-model="rowInfo.carRentalLong"
                placeholder="用车类型"
                style="width: 220px"
                clearable>
                <el-option key="4" label="半日租" :value="4"></el-option>
                <el-option key="8" label="日租" :value="8"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
             <el-form-item label="起始地点" prop="startPointName">
               <el-input v-model="rowInfo.startPointName" readonly placeholder="请输入起始地点" style="width: 220px" @focus="selectAddress('start')"/>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束地点" prop="endPointName">
              <el-input v-model="rowInfo.endPointName" readonly placeholder="请输入结束地点" style="width: 220px" @focus="selectAddress('end')"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="rowInfo.orderType=='10030002'">
          <el-col :span="12">
             <el-form-item label="租车数量" prop="carNumber">
                <el-select
                  :disabled="rowInfo.id==''?false:true"
                  v-model="rowInfo.carNumber"
                  placeholder="租车数量"
                  style="width: 220px"
                  clearable>
                  <el-option key="1" label="1辆" :value="1"></el-option>
                  <el-option key="2" label="2辆" :value="2"></el-option>
                  <el-option key="3" label="3辆" :value="3"></el-option>
                  <el-option key="4" label="4辆" :value="4"></el-option>
                  <el-option key="5" label="5辆" :value="5"></el-option>
                  <el-option key="6" label="6辆" :value="6"></el-option>
                  <el-option key="7" label="7辆" :value="7"></el-option>
                  <el-option key="8" label="8辆" :value="8"></el-option>
                  <el-option key="9" label="9辆" :value="9"></el-option>
                  <el-option key="10" label="10辆" :value="10"></el-option>
                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12"  v-if="rowInfo.orderType=='10030002'">
             <el-form-item label="乘车人"  prop="passengerIds">
               <el-select
                 :disabled="rowInfo.id==''?false:true"
                 v-model="rowInfo.passengerIds"
                 placeholder="请选择乘车人"
                 filterable
                 :multiple="true"
                 style="width:220px"
                 clearable>
                  <el-option
                    v-for="code in options"
                    :key="code.perId"
                    :label="code.perName"
                    :value="code.perId"/>
                </el-select>
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
            <el-col :span="12" v-if="rowInfo.orderType=='10030001'">
             <el-form-item label="乘车人数" prop="personNumber">
                <el-select
                  v-model="rowInfo.personNumber"
                  placeholder="乘车人数"
                  style="width: 220px"
                  clearable>
                  <el-option key="1" label="1人" :value="1"></el-option>
                  <el-option key="2" label="2人" :value="2"></el-option>
                  <el-option key="3" label="3人" :value="3"></el-option>
                  <el-option key="4" label="4人" :value="4"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
           <el-form-item label="用车时间"  prop="carTime">
              <el-date-picker
                v-model="rowInfo.carTime"
                type="datetime"
                placeholder="用车时间"
                value-format="yyyy-MM-dd HH:mm"
                format="yyyy-MM-dd HH:mm"
                style="width: 220px">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="showOther">
          <el-row>
          <el-col :span="12">
             <el-form-item label="发车时间" prop="departureTime">
               <el-date-picker
                 v-model="rowInfo.departureTime"
                 type="datetime"
                 placeholder="发车时间"
                 value-format="yyyy-MM-dd HH:mm:ss"
                 format="yyyy-MM-dd HH:mm:ss"
                 style="width: 220px">
                </el-date-picker>
             </el-form-item>
          </el-col>
          <el-col :span="12">
           <el-form-item label="结束时间"  prop="endTime">
              <el-date-picker
                v-model="rowInfo.endTime"
                type="datetime"
                placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                style="width: 220px">
                </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
             <el-form-item label="起始里程" prop="startMileage">
               <el-input v-model="rowInfo.startMileage" placeholder="起始里程" style="width: 220px"/>
             </el-form-item>
          </el-col>
          <el-col :span="12">
             <el-form-item label="结束里程" prop="endMileage">
               <el-input v-model="rowInfo.endMileage" placeholder="结束里程" style="width: 220px"/>
             </el-form-item>
          </el-col>
        </el-row>
        <el-row>
           <el-col :span="12">
             <el-form-item label="使用里程" prop="mileage">
               <el-input v-model="rowInfo.mileage" placeholder="使用里程" style="width: 220px"/>
             </el-form-item>
          </el-col>
          <el-col :span="12">
             <el-form-item label="住宿费" prop="putUpFee">
               <el-input v-model="rowInfo.putUpFee" placeholder="住宿费" style="width: 220px"/>
             </el-form-item>
          </el-col>
        </el-row>
         <el-row>
         <el-col :span="12">
             <el-form-item label="停车费" prop="parkingFee">
               <el-input v-model="rowInfo.parkingFee" placeholder="停车费" style="width: 220px"/>
             </el-form-item>
          </el-col>
          <el-col :span="12">
             <el-form-item label="高速费" prop="highSpeedFee">
               <el-input v-model="rowInfo.highSpeedFee" placeholder="高速费" style="width: 220px"/>
             </el-form-item>
          </el-col>
        </el-row>
        </template>
        <el-row>
         <el-col :span="24">
            <el-form-item label="是否公海订单" prop="isHighSeas">
              <select-text v-model="rowInfo.isHighSeas" code-set-id="1006"  placeholder="是否公海订单" style="width: 220px;"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
             <el-form-item label="途经地点"  prop="passengerIds">
                <div style="float: right;display: inline;">
                   <el-button type="primary"  size="mini" icon="el-icon-plus"  @click="selectAddress('pass')" circle></el-button>
                </div>
             </el-form-item>
             <div v-for="(item,index) in rowInfo.passingPlaceList" :key="index" class="text item" style="margin-left: 100px;">
              <div><span>{{item.pointName}}</span><span style="float: right;margin-right: 20px;color: #1ea0ff;cursor: pointer" @click="delPoint(index)">移除</span></div>
             </div>
          </el-col>
        </el-row>
      </el-form>
    </span>
    <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="submitForm('rowInfo')">保存</el-button>
        <el-button size="mini"  @click="closeForm">取消</el-button>
    </span>
  </el-dialog>
  <select-address v-if="showAddVisible" ref="addAddress" @refresh="addAddress"/>
  </div>
</template>
<script>
import SelectText from '@/components/SelectText/index.vue'
import { addListpage,getDynamicFormValue,queryEmpList } from  "@/api/order/orderinfo"
import selectAddress from './select-address'
import { citys } from '@/const/city.js'
import { getCusListpage } from  "@/api/cus/cusinfo"
import { getListpage } from  "@/api/cus/empinfo"
import { mapGetters } from 'vuex';
export default {
  components: {
    SelectText,selectAddress
  },
  computed: {
    headers() {
      return {
        Authorization: `Bearer ${this.accessToken}`,
      };
    },
    ...mapGetters(['accessToken'])
  },
  data() {
    var checkStartAddress = (rule, value, callback) => {
      if (this.rowInfo.startPointLatitude==''||this.rowInfo.startPointLongitude=='') {
        callback(new Error('请选择起始地点'));
      }
      callback();
    };
    var checkEndAddress = (rule, value, callback) => {
      if (this.rowInfo.endPointLatitude==''||this.rowInfo.endPointLongitude=='') {
        callback(new Error('请选择结束地点'));
      }
      callback();
    };
    return {
      visible: false,
      showAddVisible: false,
      formName: '新增',
      locationPoint: null,
      pointsList:[],
      points:[],
      canUse:true,    //校验点坐标重叠标识
      loading: false,
      options:[],
      cusList: [],
      cusEmpList: [],
      showOther:false,
      rowInfo: {
        id: '',
        cusId:'',
        userId:'',
        cityCode:'',
        cityName:'',
        orderStatus:'',
        orderType:'10030001',
        carRentalLong:8,
        startPointLongitude:'',
        startPointLatitude:'',
        startPointName:'',
        endPointLongitude:'',
        endPointLatitude:'',
        endPointName:'',
        carNumber:1,//默认1辆
        personNumber:1,
        carTime:'',
        passengerList:[],
        passengerIds:[],
        passingPlaceList:[],
        departureTime:'',
        endTime:'',
        startMileage:'',
        endMileage: '',
        mileage:'',
        putUpFee:'',
        parkingFee:'',
        highSpeedFee:'',
        isHighSeas:''
      },
      rules: {
        orderType: [{ required: true, message: '必填:租车类型', trigger: 'change' }],
        carRentalLong: [{ required: true, message: '必填:用车类型', trigger: 'change' }],
        startPointName: [{ required: true, message: '必填:起始地点', trigger: 'blur' },
          { validator: checkStartAddress, trigger: 'change' }],
        endPointName: [{ required: true, message: '必填:结束地点', trigger: 'blur' },
          { validator: checkEndAddress, trigger: 'change' }],
        carNumber: [{ required: true, message: '必填:租车数量', trigger: 'change' }],
        personNumber: [{ required: true, message: '必填:乘车人数', trigger: 'change' }],
        carTime: [{ required: true, message: '必填:用车时间', trigger: 'blur' }],
        isHighSeas: [{ required: true, message: '必填:是否公海', trigger: 'change' }],
        startMileage: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        endMileage:  [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        mileage: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        putUpFee: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        parkingFee: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
        highSpeedFee: [
          {
            pattern: /^(([1-9]{1}\d{0,9})|(0{1}))(\.\d{1,2})?$/,
            message: "请输入合法的数字，最多两位小数",
            trigger: "change"
          }
        ],
      }
    }
  },
  //这里运用async/await 进行异步处理，保证BMap加载进来后才执行后面的操作
  async mounted() {
  },
  watch:{
    'rowInfo.startPointName'(newVal,oldVal){
      if(newVal != oldVal && newVal == ""){
        this.rowInfo.startPointLongitude = '';
        this.rowInfo.startPointLatitude = '';
        this.rowInfo.cityCode = '';
        this.rowInfo.cityName = '';
      }
    },
    'rowInfo.endPointName'(newVal,oldVal){
      if(newVal != oldVal && newVal == ""){
        this.rowInfo.endPointLongitude = '';
        this.rowInfo.endPointLatitude = '';
      }
    },
    'rowInfo.orderType'(newVal,oldVal){
      if(newVal != oldVal && newVal == "10030002"){//代叫
        this.rules.passengerIds = [{ required: true, message: '必填:乘车人', trigger: 'change' }];
      }else{
        this.rules.passengerIds = [];
      }
    },
    'rowInfo.cusId'(newVal,oldVal){
      if(this.rowInfo.id=='') {//新增
        if(newVal!=''){
          this.loadCusEmpList();//加载下单人列表
          this.loadEmpLlist(newVal);//加载乘车人
        }else{
          this.cusEmpList = [];
          this.options = [];
          this.rowInfo.userId ='';
          this.rowInfo.passengerIds =[];
        }
      }
    },
  },
  methods: {
    init(id) {
      this.visible = true
      this.rowInfo.id = id
      if (id) {
        getDynamicFormValue(id).then((res) => {
            if(res.data.code==0){
              let data = res.data
              this.rowInfo = data.data;
              this.rowInfo.passengerIds = [];
              if(this.rowInfo.passengerList){
                this.rowInfo.passengerList.forEach(item=>{
                  this.rowInfo.passengerIds.push(item.perId);
                })
              }
              if(this.rowInfo.orderStatus!='10050001'&&this.rowInfo.orderStatus!='10050002'){
                this.rules['departureTime'] = [{ required: true, message: '必填:发车时间', trigger: 'blur' }];
                if(this.rowInfo.orderStatus!='10050003'){
                  this.rules['endTime'] = [{ required: true, message: '必填:结束时间', trigger: 'blur' }];
                }else{
                  this.rules['endTime'] = [];
                }
                this.showOther = true;
              }else{
                this.rules['departureTime']=[];
                this.rules['endTime'] = [];
                this.showOther = false;
              }
              this.loadEmpLlist(data.data.cusId);
            }
        })
      }else{
        this.loadCusList();
      }
    },
    //加载企业列表
    loadCusList() {
      let params = {};
      params.status= 1;//启用的
      params.page= 1;
      params.limit = 10000;
      getCusListpage(params).then(res => {
        this.cusList = res.data.records
      })
    },
    //加载员工列表
    loadCusEmpList() {
      let params = {};
      params.status= 1;//启用的
      params.page= 1;
      params.limit = 10000;
      params.cusId = this.rowInfo.cusId;
      getListpage(params).then(res => {
        this.cusEmpList = res.data.records
      })
    },
    loadEmpLlist(cusId){
      //加载企业下的乘车人
      queryEmpList({'cusId':cusId}).then((res) => {
        if(res.data.code==0){
          let data = res.data;
          if(data.data) {
            let list = [];
            data.data.forEach(person => {
              if (person.persons.length > 0) {
                for (let i = 0; i < person.persons.length; i++) {
                  let per = {};
                  per.perId = person.persons[i].perId;
                  per.perName = person.persons[i].perName;
                  list.push(per);
                }
              }
            });
            this.options = list;
          }
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.rowInfo.passengerIds.length>0){
            this.rowInfo.passengerList = [];
            this.options.forEach(item=>{
              if(this.rowInfo.passengerIds.indexOf(item.perId)!=-1){
                this.rowInfo.passengerList.push(item);
              }
            })
          }
          let formInfo = JSON.parse(JSON.stringify(this.rowInfo));
          formInfo.passengerList = JSON.stringify(this.rowInfo.passengerList);
          formInfo.passingPlaceList = JSON.stringify(this.rowInfo.passingPlaceList);
          addListpage(formInfo).then((res) => {
            if (res.data.code==0){
              // 在store中改变修改的值
              if (this.rowInfo.id) {
                this.$message.success("编辑成功")
              } else {
                this.$message.success("添加成功")
              }
              // 子组件中触发父组件的初始化方法
              this.$emit('refresh', '')
              // 关闭弹框
              this.closeForm()
            }
          })
        } else {
          return false
        }
      })
    },
    closeForm() {
      this.visible = false
      // 重置表单
      this.$refs['rowInfo'].resetFields()
      this.rowInfo = {
        id: '',
        cityCode:'',
        cityName:'',
        orderStatus:'',
        orderType:'10030001',
        carRentalLong:'8',
        startPointLongitude:'',
        startPointLatitude:'',
        startPointName:'',
        endPointLongitude:'',
        endPointLatitude:'',
        endPointName:'',
        carNumber:'1',//默认1辆
        personNumber:'1',
        carTime:'',
        passengerList:[],
        passengerIds:[],
        passingPlaceList:[],
        departureTime:'',
        endTime:'',
        startMileage:'',
        endMileage: '',
        mileage:'',
        putUpFee:'',
        parkingFee:'',
        highSpeedFee:''
      }
    },
    selectAddress(current){
      if(current=='pass'&&this.rowInfo.passingPlaceList.length>=5){
        this.$message.warning("途经地点最多添加5个地点");
        return;
      }
      this.showAddVisible = true;
      this.$nextTick(() => {
        this.$refs.addAddress.init(current,this.rowInfo.cityCode)
      })
    },
    //添加途经地点
    addAddress(current,address){
      if(current=='pass'){
        this.rowInfo.passingPlaceList.push(address);
        this.$set(this.rowInfo,"passingPlaceList",this.rowInfo.passingPlaceList);
      }
      if(current=='start'){
        this.$set(this.rowInfo,"cityCode",address.cityCode);
        this.$set(this.rowInfo,"cityName",address.cityName);
        this.$set(this.rowInfo,"startPointName",address.pointName);
        this.$set(this.rowInfo,"startPointLongitude",address.pointLongitude);
        this.$set(this.rowInfo,"startPointLatitude",address.pointLatitude);
      }
      if(current=='end'){
        this.$set(this.rowInfo,"endPointName",address.pointName);
        this.$set(this.rowInfo,"endPointLongitude",address.pointLongitude);
        this.$set(this.rowInfo,"endPointLatitude",address.pointLatitude);
      }
    },
    handleUploadSuccess(res) {
      //
    },

    //移除途经地点
    delPoint(index){
      this.rowInfo.passingPlaceList.splice(index,1);
      console.log(this.rowInfo.passingPlaceList.length);
    }
  }
}
</script>
<style scoped  rel="stylesheet/scss">
  .sideBarForm{
    overflow: auto;
    height: calc(100vh - 80px);
    margin-top: 40px;
  }
  .fullScreen .formHead,.fullScreen .formButton{
    right: 0;
  }
  .formHead{
    position: fixed;
    right:-420px;
    top:0;
    background-color: #27c3dc;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
  }
  .formBack{
    width: 40px;
    text-align: center;
    height: 100%;
    background-color: #ffbf00;
    font-size: 16px;
    color:#ffffff;
    line-height: 40px;
    cursor: pointer;
  }
  .listName{
    color:#ffffff;
    font-size: 16px;
    line-height: 40px;
    padding-left: 20px;
  }
  .formContent{
    padding: 20px;
  }
  .formButton{
    position: fixed;
    right:-420px;
    bottom:0;
    background-color: #ffffff;
    height: 40px;
    width: 420px;
    display: flex;
    transition: all 0.5s;
    z-index:1100;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
